exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".section-header[data-v-5ce1c20e]{border-left:5px solid #569cf3}.section-h2[data-v-5ce1c20e]{font-size:1.4em;line-height:1}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/routes/Home.vue"],"names":[],"mappings":"AAsBA,iCACE,6BAA+B,CAChC,AACD,6BACE,gBAAiB,AACjB,aAAe,CAChB","file":"Home.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.section-header[data-v-5ce1c20e] {\n  border-left: 5px solid #569cf3;\n}\n.section-h2[data-v-5ce1c20e] {\n  font-size: 1.4em;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ce1c20e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/routes/Home.vue
// module id = 832
// module chunks = 5